import { Component, input, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { COMMUNITY_DEFAULT_AVATAR } from '@outlaw/core';
import { CommunityNavigationService } from '../../../../services/navigation/community-navigation.service';
import { PostUser } from '../../../../interfaces/community-item';

@Component({
  selector: 'app-post-comment',
  templateUrl: './post-comment.component.html',
  styleUrls: ['./post-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostCommentComponent {
  postId = input<string>();
  commentText = input<string>();
  userInfo = input<PostUser>();

  #navigationService = inject(CommunityNavigationService);

  postUrl = computed(() => {
    return this.#navigationService.getPostUrl(this.postId());
  });

  readonly defaultAvatar = COMMUNITY_DEFAULT_AVATAR;
}
